import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, FileTextIcon } from 'lucide-react';
export function Deliverables() {
  return <section className="bg-[#FDF8F3] py-20 px-6" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-[#3BBFAD]/10" data-id="element-19">
            <h2 className="font-serif text-3xl text-[#1B2A4A] mb-8 text-center" data-id="element-20">
              Lo que recibes{' '}
              <span className="text-base font-sans font-normal text-gray-500 block mt-2" data-id="element-21">
                (para que no quede duda)
              </span>
            </h2>

            <ul className="space-y-6" data-id="element-22">
              <li className="flex items-start gap-4 p-4 rounded-xl bg-[#FDF8F3]/50 hover:bg-[#FDF8F3] transition-colors" data-id="element-23">
                <div className="bg-[#3BBFAD] p-2 rounded-full text-white shrink-0" data-id="element-24">
                  <FileTextIcon className="w-5 h-5" data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <h3 className="font-bold text-[#1B2A4A] text-lg" data-id="element-27">
                    PDF “La Ruta Clara”
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-28">
                    Guía completa 18–24 meses
                  </p>
                </div>
              </li>

              <li className="flex items-start gap-4 p-4 rounded-xl bg-[#FDF8F3]/50 hover:bg-[#FDF8F3] transition-colors" data-id="element-29">
                <div className="bg-[#3BBFAD] p-2 rounded-full text-white shrink-0" data-id="element-30">
                  <CheckIcon className="w-5 h-5" data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <h3 className="font-bold text-[#1B2A4A] text-lg" data-id="element-33">
                    Checklist Semáforo
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-34">
                    1 página: Verde / Amarillo / Rojo
                  </p>
                </div>
              </li>

              <li className="flex items-start gap-4 p-4 rounded-xl bg-[#FDF8F3]/50 hover:bg-[#FDF8F3] transition-colors" data-id="element-35">
                <div className="bg-[#3BBFAD] p-2 rounded-full text-white shrink-0" data-id="element-36">
                  <CheckIcon className="w-5 h-5" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <h3 className="font-bold text-[#1B2A4A] text-lg" data-id="element-39">
                    Tracker Imprimible (7 días)
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-40">
                    Versión completa + versión de 1 hoja
                  </p>
                </div>
              </li>

              <li className="flex items-start gap-4 p-4 rounded-xl bg-[#FDF8F3]/50 hover:bg-[#FDF8F3] transition-colors" data-id="element-41">
                <div className="bg-[#3BBFAD] p-2 rounded-full text-white shrink-0" data-id="element-42">
                  <CheckIcon className="w-5 h-5" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h3 className="font-bold text-[#1B2A4A] text-lg" data-id="element-45">
                    Guiones Copy/Paste
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-46">
                    Para pediatra, daycare y pareja/familia
                  </p>
                </div>
              </li>

              <li className="flex items-start gap-4 p-4 rounded-xl bg-[#FDF8F3]/50 hover:bg-[#FDF8F3] transition-colors" data-id="element-47">
                <div className="bg-[#3BBFAD] p-2 rounded-full text-white shrink-0" data-id="element-48">
                  <CheckIcon className="w-5 h-5" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h3 className="font-bold text-[#1B2A4A] text-lg" data-id="element-51">
                    Plantilla “Paquete de Evidencia”
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-52">
                    Qué llevar a la consulta y cómo decirlo
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}